module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shipping_error_text":"There was error during prosessing your shipping. You can either retry with same shipper ({method}) or select new."},"id":{"shipping_error_text":"Terjadi kesalahan saat memproses pengiriman kamu. kamu dapat mencoba lagi dengan pengirim yang sama ({method}) atau pilih baru."}}')
  delete Component.options._Ctor
}
